module.exports = __webpack_public_path__ + "img/国家地质灾害气象预警互联子系统.512d78f6.jpg";